<div class="bucket-progress" [attr.aria-label]="'Bucket progress ' + roundedProgressPercent + '%'" role="img">
  <svg class="bucket-progress__ring" viewBox="0 0 120 120" aria-hidden="true">
    <circle
      class="bucket-progress__circle bucket-progress__circle--background"
      [class.bucket-progress__circle--track-primary]="progressColor === 'primary'"
      [class.bucket-progress__circle--track-warn]="progressColor === 'warn'"
      cx="60"
      cy="60"
      r="46"
    />
    <circle
      class="bucket-progress__circle bucket-progress__circle--progress"
      [class.bucket-progress__circle--primary]="progressColor === 'primary'"
      [class.bucket-progress__circle--warn]="progressColor === 'warn'"
      cx="60"
      cy="60"
      r="46"
      [attr.stroke-dasharray]="ringCircumference"
      [attr.stroke-dashoffset]="progressOffset"
    />
  </svg>
</div>
